import * as tailwindConfigFile from '../../tailwind.config'

export const tailwindConfig = tailwindConfigFile
